import { useState } from 'react'

import { type IUpdateFeedback, type IUnpublishedFeedback, type IFeedbacksDatesFilter } from '@/app/types/doctorsType'
import { Button, PageWrapper } from '@/shared'

import { FeedbacksModal } from './FeedbacksModal/FeedbacksModal'
import style from './UnpublishedFeedbacks.module.scss'

interface IProps {
    unpublishedFeedbacks: IUnpublishedFeedback[]
    feedbacksDatesFilter: IFeedbacksDatesFilter
    isFetchingFeedbacks: boolean
    onGetUnpublishedFeedbacks: () => void
    onRemoveFeedback: (id: string, feedbackId: string, isPublished: boolean) => void
    onPublishFeedback: (dto: IUpdateFeedback) => void
    onSetFeedbackStartDatefilter: (startDate: string | null) => void
    onSetFeedbackEndDatefilter: (endDate: string | null) => void
}

export const UnpublishedFeedbacks = (props: IProps) => {
    const {
        unpublishedFeedbacks,
        feedbacksDatesFilter,
        isFetchingFeedbacks,
        onGetUnpublishedFeedbacks,
        onRemoveFeedback,
        onPublishFeedback,
        onSetFeedbackStartDatefilter,
        onSetFeedbackEndDatefilter
    } = props
    const [isOpenModal, setIsOpenModal] = useState<boolean>(false)

    return (
        <PageWrapper>
            <FeedbacksModal
                isOpenModal={isOpenModal}
                unpublishedFeedbacks={unpublishedFeedbacks}
                feedbacksDatesFilter={feedbacksDatesFilter}
                isFetchingFeedbacks={isFetchingFeedbacks}
                onGetUnpublishedFeedbacks={onGetUnpublishedFeedbacks}
                setIsOpenModal={setIsOpenModal}
                onRemoveFeedback={onRemoveFeedback}
                onPublishFeedback={onPublishFeedback}
                onSetFeedbackStartDatefilter={onSetFeedbackStartDatefilter}
                onSetFeedbackEndDatefilter={onSetFeedbackEndDatefilter}
            />
            <div className={style.container}>
                <div className={style.title}>
                    <span>
                        Неопубликованные отзывы:{' '}
                        <span className={style.quantity}>{unpublishedFeedbacks?.length || 0}</span>
                    </span>
                </div>
                <div className={style.btn}>
                    <Button onClick={() => setIsOpenModal(true)}>{'Показать'}</Button>
                </div>
            </div>
        </PageWrapper>
    )
}
